// extracted by mini-css-extract-plugin
module.exports = {"banner":"promotion_banner__VAaEs","target_link":"promotion_target_link__3_TFC"};